export const env = 'dev';

const config = {
    dev:{
        apiUrl: 'https://api.dev.tweedlmusic.com',
        functionsApi:'https://us-central1-tweedl-dev-24b55.cloudfunctions.net',
        firebase:{
            apiKey: "AIzaSyBUrnArQLwW6ZB4B2soq8M_SfrPYgCxYm8",
            authDomain: "tweedl-dev-24b55.firebaseapp.com",
            databaseURL: "https://tweedl-dev-24b55.firebaseio.com",
            projectId: "tweedl-dev-24b55",
            storageBucket: "tweedl-dev-24b55.appspot.com",
            messagingSenderId: "761186651002",
            appId: "1:761186651002:web:828db6b936b7d96d7ca4c3"
        },
        cloudinaryPublicUrl: 'https://res.cloudinary.com/tweedl-dev/image/upload/',
        mediaStreamingHost: 'https://media.dev.tweedlmusic.com',
    },
    stage: {
        apiUrl: 'https://api.stage.tweedlmusic.com',
        functionsApi:'https://us-central1-tweedl-stage.cloudfunctions.net',
        mediaStreamingHost: 'https://media.stage.tweedlmusic.com',
        firebase: {
            apiKey: 'AIzaSyAu3BDc0eF2wBxGNTrZ_akoNVEutqR8skY',
            authDomain: 'tweedl-stage.firebaseapp.com',
            databaseURL: 'https://tweedl-stage.firebaseio.com',
            projectId: 'tweedl-stage',
            storageBucket: 'tweedl-stage.appspot.com',
            messagingSenderId: '519611113667'
        },
        cloudinaryPublicUrl: 'https://res.cloudinary.com/tweedl-dev/image/upload/',
       },
    prod:{
        apiUrl: 'https://api.tweedlmusic.com',
        functionsApi:'https://us-central1-tweedl-prod.cloudfunctions.net',
        firebase:{
            apiKey: 'AIzaSyBMHlM1AcIDz8Hqy0Jje6Ha_iZY1LEBsDg',
            authDomain: 'tweedl-prod.firebaseapp.com',
            databaseURL: 'https://tweedl-prod.firebaseio.com',
            projectId: 'tweedl-prod',
            storageBucket: 'tweedl-prod.appspot.com',
            messagingSenderId: '1059860039708',
            appId: "1:761186651002:web:828db6b936b7d96d7ca4c3"
        },
        cloudinaryPublicUrl: 'https://res.cloudinary.com/tweedl-dev/image/upload/',
        mediaStreamingHost: 'https://media.tweedlmusic.com',
    }
};

export default config[env]